import type { InteractionVisualStateRuntime } from './AbstractInteractionVisualState';
import type { Viewer } from '../../viewer/Viewer';
import { SketchDefaultTransitionState } from './SketchDefaultTransitionState';

/**
 * 草图复制实体视觉状态。
 */
export class SketchCopyEntitiesTransitionState extends SketchDefaultTransitionState {
    /**
     * @param runtime 状态运行时。
     * @param viewer Viewer 实例。
     */
    public constructor(runtime: InteractionVisualStateRuntime, viewer: Viewer) {
        super(runtime, viewer);
    }
}
